import React from 'react'

import i18n from 'live/services/i18n'

import { SystemAuditCard } from './components/SystemAuditCard/SystemAuditCard'
import { CardListNoData, NoInfo, SystemAuditCardListContainer } from './styles'
import { SystemAuditContentView } from './components'
import { Scrollbars } from '../../../../../generic'

interface IProps {
    systemAuditData: ISystemAudit[]
    height: number
    loading: boolean
}

export const SystemAuditCardList: React.FC<IProps> = ({ systemAuditData, height, loading }) => {
    return (
        <SystemAuditCardListContainer style={{ height }}>
            {console.log('height->', height)}
            {loading ? (
                <NoInfo>
                    <i className="fa fa-spinner fa-spin" />
                </NoInfo>
            ) : systemAuditData?.length > 0 ? (
                <>
                    <Scrollbars>
                        {systemAuditData?.map((le, index) => {
                            return (
                                <SystemAuditContentView
                                    data={le}
                                    maxHeight={height - 60 * 3 - 50}
                                    key={`card-${index}`}
                                />
                                // <SystemAuditCard
                                //     key={`card-${index}`}
                                //     timespan={le.date}
                                //     httpVerb={le.httpVerb}
                                //     statusCode={le.statusCode}
                                //     endpoint={le.endpoint}
                                //     liveAuthor={le.liveAuthor}
                                //     response={le.response}
                                //     pluginName={le.pluginName}
                                //     maxHeight={height - 8 * 3 - 64 * 3}
                                //     statusCodeStatus={le.statusCodeStatus}
                                //     description={le.commonQuestionsDto.what}
                                //     payload={le.payload}
                                // />
                            )
                        })}
                    </Scrollbars>
                </>
            ) : (
                <CardListNoData>
                    <div>{i18n('No data for the selected period. Select a different timespan and try again.')}</div>
                </CardListNoData>
            )}
        </SystemAuditCardListContainer>
    )
}
